<div
  class="p-6 bg-surface dark:bg-surface-darkmode text-on-surface dark:text-on-surface-darkmode rounded-md inline-flex flex-col gap-6"
>
  <div class="flex gap-2">
    <ui-button
      size="small"
      mode="outlined"
      [iconOnly]="true"
      class="flex-none"
      (click)="onClickPrevious()"
      [disabled]="disabled()"
      type="button"
    >
      <ng-icon name="heroChevronLeft" size="20" class="!block" />
    </ui-button>
    <div class="flex-1 flex items-center justify-center text-sm font-normal leading-5">
      {{ month() | date: 'MMMM yyyy' }}
    </div>
    <ui-button
      size="small"
      mode="outlined"
      [iconOnly]="true"
      class="flex-none"
      (click)="onClickNext()"
      [disabled]="disabled()"
      type="button"
    >
      <ng-icon name="heroChevronRight" size="20" class="!block" />
    </ui-button>
  </div>
  <div class="flex flex-col gap-1.5">
    <div
      class="grid grid-cols-7 text-xs font-semibold text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
    >
      @for (day of weekDays(); track day.getTime()) {
        <div class="text-xs font-normal leading-4 text-center">{{ day | date: 'E' }}</div>
      }
    </div>
    <div
      class="grid grid-cols-7 text-xs font-semibold text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
    >
      @for (week of weeksOfMonth(); track $index) {
        @for (day of week; track $index) {
          <button
            class="p-2.5 size-9 inline-flex items-center justify-center text-xs font-normal leading-4"
            [ngClass]="[
              disabled() ? 'cursor-not-allowed' : 'cursor-pointer',
              {
                start:
                  'rounded-s-full bg-primary dark:bg-primary-darkmode text-on-primary dark:text-on-primary-darkmode disabled:bg-primary-disabled disabled:dark:bg-primary-disabled-darkmode disabled:text-on-primary-disabled disabled:dark:text-on-primary-disabled-darkmode',
                end: 'rounded-e-full bg-primary dark:bg-primary-darkmode text-on-primary dark:text-on-primary-darkmode disabled:bg-primary-disabled disabled:dark:bg-primary-disabled-darkmode disabled:text-on-primary-disabled disabled:dark:text-on-primary-disabled-darkmode',
                startAndEnd:
                  'rounded-full bg-primary dark:bg-primary-darkmode text-on-primary dark:text-on-primary-darkmode disabled:bg-primary-disabled disabled:dark:bg-primary-disabled-darkmode disabled:text-on-primary-disabled disabled:dark:text-on-primary-disabled-darkmode',
                selected:
                  'bg-surface-highlight dark:bg-surface-highlight-darkmode text-on-primary-soft dark:text-on-primary-soft-darkmode disabled:bg-surface-variant disabled:dark:disabled:bg-surface-variant-darkmode disabled:text-on-surface-variant disabled:dark:disabled:text-on-surface-variant-darkmode',
                inRange:
                  'rounded-full hover:bg-primary-soft dark:hover:bg-primary-soft-darkmode hover:text-on-primary-soft dark:hover:text-on-primary-soft-darkmode disabled:bg-surface disabled:dark:bg-surface-darkmode disabled:text-on-surface disabled:dark:text-on-surface-darkmode',
                outOfRange:
                  'rounded-full text-on-surface-disabled dark:text-on-surface-disabled-darkmode hover:bg-surface-highlight dark:hover:bg-surface-highlight-darkmode hover:text-on-surface-highlight dark:hover:text-on-surface-highlight-darkmode disabled:bg-surface disabled:dark:bg-surface-darkmode disabled:text-on-surface-disabled disabled:dark:text-on-surface-disabled-darkmode',
              }[day.status],
            ]"
            type="button"
            [disabled]="disabled()"
            (click)="onClickDay(day.date)"
          >
            {{ day.date | date: 'd' }}
          </button>
        }
      }
    </div>
  </div>
</div>
